<template>
  <div class="wrapper">
    <section class="main">
      <main-section></main-section>
    </section>
    <EventsSection />
    <!--    <section class="schedule my-8">-->
    <!--      <schedule></schedule>-->
    <!--    </section>-->
    <section class="lectors">
      <lectors></lectors>
    </section>
    <section class="location">
      <!-- <location /> -->
    </section>
    <section class="partners">
      <partners />
    </section>
  </div>
</template>

<script>
import MainSection from "./MainPage/MainSection";
// import Schedule from "./MainPage/Schedule";
import Lectors from "@/views/MainPage/Lectors";
// import Location from "@/views/MainPage/Location";
import Partners from "@/views/MainPage/Partners";
import EventsSection from "@/views/MainPage/EventsSection.vue";

export default {
  name: "Main",
  components: {
    EventsSection,
    MainSection,
    // Schedule,
    Lectors,
    // Location,
    Partners
  },
  data: () => ({})
};
</script>

<style lang="sass" scoped>
.wrapper
    width: 100%
</style>
